import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { DollarSign } from 'lucide-react';
import { Transcription } from '@/types/transcription';

interface TranscriptionCostsCardProps {
  currentTranscription: Transcription | null;
  transcriptions: Transcription[];
}

export const TranscriptionCostsCard = ({ 
  currentTranscription, 
  transcriptions 
}: TranscriptionCostsCardProps) => {
  // Calculate total costs
  const totalCost = transcriptions.reduce((sum, t) => sum + (t.total_cost || 0), 0);
  
  // Calculate monthly costs
  const now = new Date();
  const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const monthlyCost = transcriptions
    .filter(t => new Date(t.created_at) >= startOfMonth)
    .reduce((sum, t) => sum + (t.total_cost || 0), 0);

  return (
    <Card className="w-64">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm flex items-center gap-2">
          <DollarSign className="h-4 w-4 text-primary" />
          API Kosten
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {currentTranscription && (
          <>
            <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">Dit transcript:</span>
              <span className="font-mono font-medium">
                ${(currentTranscription.total_cost || 0).toFixed(4)}
              </span>
            </div>
            <div className="flex justify-between text-xs text-muted-foreground">
              <span>• Whisper:</span>
              <span className="font-mono">${(currentTranscription.whisper_cost || 0).toFixed(4)}</span>
            </div>
            <div className="flex justify-between text-xs text-muted-foreground">
              <span>• GPT-4o:</span>
              <span className="font-mono">${(currentTranscription.gpt_cost || 0).toFixed(4)}</span>
            </div>
            <Separator className="my-2" />
          </>
        )}
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">Deze maand:</span>
          <span className="font-mono font-medium text-primary">
            ${monthlyCost.toFixed(4)}
          </span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">Totaal:</span>
          <span className="font-mono font-medium">
            ${totalCost.toFixed(4)}
          </span>
        </div>
      </CardContent>
    </Card>
  );
};
